export const createSampleBoxApplicationAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }